import { isVideoFilename } from "../../../utils";
import type { MediaItem } from "../../../types";

interface Props {
  item: MediaItem;
  isFav: boolean;
  isSelected: boolean;
  selectMode: boolean;
  isNew: boolean;
  onView: () => void;
  onToggleSelect: () => void;
  onDelete: () => void;
}

function formatSize(size?: number): string {
  if (!Number.isFinite(size)) return "—";
  const n = size as number;
  return n > 1024 * 1024 ? (n / (1024 * 1024)).toFixed(2) + " MB" : (n / 1024).toFixed(2) + " KB";
}

function formatDate(item: MediaItem): string {
  const dateValue = item.updatedAt || item.addedAt || item.uploadedAt;
  const dateObj = dateValue ? new Date(dateValue) : null;
  return dateObj && !Number.isNaN(dateObj.getTime()) ? dateObj.toLocaleDateString() : "—";
}

export function GalleryListItem({ item, isFav, isSelected, selectMode, isNew, onView, onToggleSelect, onDelete }: Props) {
  const icon = isVideoFilename(item.filename) ? "camera-video-fill" : "image-fill";

  return (
    <div
      className={`list-group-item d-flex align-items-center justify-content-between${isSelected ? " is-selected" : ""}`}
      data-filename={item.filename}
      onClick={selectMode ? onToggleSelect : undefined}
    >
      <div className="d-flex align-items-center gap-3 flex-grow-1 min-w-0">
        {selectMode ? (
          <span className={`select-check${isSelected ? " is-checked" : ""}`} aria-hidden="true">
            <i className="bi bi-check-lg" />
          </span>
        ) : (
          <i className={`bi bi-${icon} text-pink fs-4 flex-shrink-0`} />
        )}

        <div className="min-w-0 flex-grow-1">
          <div className="fw-medium media-name d-flex align-items-center gap-2">
            <span className="text-truncate">{item.filename.replace(".enc", "")}</span>
            {isFav && <i className="bi bi-heart-fill fav-heart" title="Favorite" />}
            {isNew && !selectMode && <span className="gallery-new-badge gallery-new-badge-inline">New</span>}
          </div>
          <small className="muted d-block text-truncate">
            {formatSize(item.size)} • {formatDate(item)}
          </small>
        </div>
      </div>

      {!selectMode && (
        <div className="d-flex gap-2 flex-shrink-0">
          <button className="btn btn-sm btn-outline-pink view-media-btn" type="button" onClick={onView}>
            <i className="bi bi-eye" />
            <span className="btn-label ms-1 d-none d-sm-inline">View</span>
          </button>
          <button className="btn btn-sm btn-outline-danger delete-media-btn" type="button" onClick={onDelete}>
            <i className="bi bi-trash3" />
            <span className="btn-label ms-1 d-none d-sm-inline">Delete</span>
          </button>
        </div>
      )}
    </div>
  );
}
